export async function analyticsRequest<T>(
  path: string,
  body?: unknown,
  signal?: AbortSignal,
): Promise<T> {
  const response = await fetch('/api/analytics/' + path, {
    method: body === undefined ? 'GET' : 'POST',
    headers: {
      'x-admin-token': sessionStorage.getItem('admin_token') || '',
      ...(body === undefined ? {} : { 'Content-Type': 'application/json' }),
    },
    signal,
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (!response.ok)
    throw new Error(
      body === undefined
        ? '运营数据暂时无法读取，请重试'
        : '操作未完成，请重试',
    );
  return response.json();
}
